<template>
  <div class="container">
    <div class="tbody">
      <div class="body__section-left">
        <div class="body__section-left--logo">
          <a href="/">
            <span>My</span>
            <span>Resume</span>
          </a>
        </div>
        <div class="nav">
          <ul>
            <li><a @click="goHome">Home</a></li>
            <li><a @click="goAbout">About</a></li>
            <li><a @click="goEdu">Education</a></li>
            <li><a @click="goCert">Certificate</a></li>
          </ul>
        </div>
      </div>
      <div class="body__section-right">
        <transition-group
          enter-active-class="animated lightSpeedIn"
          leave-active-class="animated lightSpeedOut"
        >
          <home key="home" v-if="homeshow"></home>
          <about key="about" v-if="aboutshow"></about>
          <edu key="edu" v-if="edushow"></edu>
          <cert key="cert" v-if="certshow"></cert>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import home from "./home.vue";
import about from "./about.vue";
import edu from "./education.vue";
import cert from "./certificate.vue"

export default {
  data() {
    return {
      email: "",
      password: "",
      certshow: false,
      homeshow: false,
      aboutshow: false,
      edushow: false,
      dburl: null,
      thisYear: "2019",
    };
  },
  methods: {
    goAbout() {
      this.aboutshow = true;
      this.homeshow = false;
      this.edushow = false;
      this.certshow = false
    },
    goHome() {
      this.homeshow = true;
      this.aboutshow = false;
      this.edushow = false;
      this.certshow = false
    },
    goEdu() {
      this.homeshow = false;
      this.aboutshow = false;
      this.edushow = true;
      this.certshow = false
    },
    goCert() {
      this.homeshow = false;
      this.aboutshow = false;
      this.edushow = false;
      this.certshow = true;
    },
  },
  created() {
    setTimeout(() => {
      this.homeshow = true;
    }, 1000);
  },
  components: {
    about,
    home,
    edu,
    cert
  },
};
</script>

<style>
@charset "utf-8";
@import url("https://fonts.googleapis.com/css?family=Quicksand:300,400,500,700");
@import url("https://fonts.googleapis.com/css?family=Roboto");
/*=============================================
Css Indexing
===============================================
1 Base CSS

===============================================*/

/*===========================================
Base CSS
============================================*/
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.tbody {
  display: flex;
}

.body__section-right--Home {
  display: flex;
  padding: 3vw;
  flex-wrap: wrap;
}

.body__section-right__top--sec-title {
  padding-top: 1vw;
  padding-left: calc(10px + 2vw);
}

.body__section-right--Home__image {
  width: calc(50vmin);
}

.body__section-right--Home__content {
  width: calc(50vmin);

  padding-left: calc(2px + 2.5vw);
}

.body__section-right__top--sec-title__pg-sub-title {
  margin-bottom: 10px;
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  color: #999999;
  font-weight: 500;
  letter-spacing: 5px;
}

.body__section-right__top--sec-title__pg-title {
  font-size: 18px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 5px;
  line-height: 1.8;
  color: #000;
}

.sm-text {
  letter-spacing: 2.1px;
  font-weight: normal;
  color: #222222;
  font-size: 14;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
}

.md-text {
  letter-spacing: 2.1px;
  font-weight: normal;
  color: #222222;
  font-size: calc(0.7rem + 0.5vw);
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
}

.name {
  font-size: calc(1rem + 1vw);
  text-transform: uppercase;
  margin: 15px 0px;
  color: #222222;
  font-family: "Roboto", sans-serif;
  font-weight: 600;
}

.role {
  font-size: calc(1rem + 0.7vw);
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  text-transform: uppercase;
  margin-bottom: 20px;
  color: #222222;
}

.text {
  font-size: 15px;
}

.pr-list {
  margin: 30px 0px;
}

.pr-list i {
  padding-right: 4px;
}

.nav {
  flex: 1;
  /* display: flex; */
  justify-content: flex-end;
  margin: 50px 0px;
}

.nav ul li,
.nav ul li a {
  display: flex;
  justify-content: flex-end;
}

.nav ul li a {
  font-size: calc(0.7rem + 0.5vw);
  padding: 8px 0px;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.4);
  letter-spacing: 1px;
  font-weight: 500;
  position: relative;
}

.nav ul li a:hover {
  color: #000;
}
.nav ul li a:after {
  content: "";
  width: 0;
  height: 1px;
  background: #000;
  position: absolute;
  bottom: 5px;
  left: 0;
  right: 0;
  -webkit-transform: scaleX(0);
  -moz-transform: scaleX(0);
  -ms-transform: scaleX(0);
  -o-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  -moz-transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  -ms-transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  -o-transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.nav ul li a:hover:after {
  width: 100%;
  -webkit-transform: scaleX(1);
  -moz-transform: scaleX(1);
  -ms-transform: scaleX(1);
  -o-transform: scaleX(1);
  transform: scaleX(1);
}

.body__section-left--logo {
  display: flex;
  justify-content: flex-end;
  margin-top: 1vw;
}

.body__section-left--logo a {
  color: #fff;
  text-align: right;
  background: #000;
  display: flex;
  flex-direction: column;
  padding: calc(0.2rem + 0.2vw);
  font-size: calc(0.5rem + 0.5vw);
  text-transform: uppercase;
  letter-spacing: 5px;
  line-height: calc(1rem + 1vw);
  font-weight: 500;
}

.body__section-left--footer__foot-contact ul {
  display: flex;
  flex-direction: column;
}

.body__section-left--footer__foot-contact ul li {
  justify-content: flex-end;
  display: flex;
  margin: 2px 0px;
}

.body__section-left--footer__foot-contact {
  font-size: calc(0.4rem + 0.6vw);
  margin: 5px 0px;
}

.body__section-left--footer__foot-contact i {
  padding-right: 4px;
}

.about {
  padding: calc(3rem);
}

.edu-img{
display: flex;
justify-content: center;
flex-wrap: wrap;
}

.edu-img img{
  width: 50vmax;
  padding: 3vw;
}

.cer-img{
display: flex;
justify-content: center;
flex-wrap: wrap;
}

.cer-img img{
  width: 30vmax;
  padding: 1vw;
}
</style>
